import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, retry } from 'rxjs';
import { environment } from '../../environments/environment';
import { EffortVarianceReport } from '../models/effort-variance-report.model';

@Injectable({ providedIn: 'root' })
export class EffortVarianceReportService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.apiUrl}/EffortVarianceReport`;

  /**
   * Allocation vs actual effort for one month.
   *
   * @param includeDrafts when true (default) hours from unsubmitted work logs count towards
   *   actuals, so the report is usable mid-month. Each row still reports its own status.
   */
  getReport(year: number, month: number, includeDrafts = true): Observable<EffortVarianceReport> {
    return this.http
      .get<EffortVarianceReport>(`${this.apiUrl}/${year}/${month}`, {
        params: { includeDrafts }
      })
      .pipe(retry(2));
  }
}
